import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL = 100;
const MIN_LEFT = 3;
export function ScarcityBar() {
  const [left, setLeft] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft(prev => prev > MIN_LEFT ? prev - 1 : prev);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const filled = (TOTAL - left) / TOTAL * 100;
  return <div className="rounded-2xl border-2 border-alert/30 bg-alert-light p-4" data-id="element-50" data-mp="2b56yqtljnvm7">
      <p className="flex items-center justify-center gap-2 text-center text-sm font-extrabold text-alert md:text-base" data-id="element-51" data-mp="2g6w884t4c186">
        <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-52" data-mp="227mv5e07ln8f" />
        Only {left} spots left at the promotional price
      </p>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-53" data-mp="ep7dwlahkuc">
        <div className="bar-stripes h-full rounded-full bg-alert transition-[width] duration-300 ease-out" style={{
        width: `${filled}%`
      }} data-id="element-54" data-mp="33lbnylhn0m09" />
      </div>
      <p className="mt-2 text-center text-xs font-semibold text-navy/70" data-id="element-55" data-mp="3dbmxqoo05pf2">
        {TOTAL - left} of {TOTAL} promotional spots already claimed
      </p>
    </div>;
}